<script setup>
const props = defineProps(['href', 'active']);
const link = props.active ? '#' : props.href;
</script>

<template>
    <div v-if="active" class="nav-link active"><slot/></div>
    <a v-else :href="link" class="nav-link"><slot/></a>
</template>